// sketchType.js
// System SKETCH type identity.

export const SKETCH_TYPE_KEY = 'SKETCH';

/**
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeSketchTypeKey(value) {
  return String(value || '').trim().toUpperCase();
}

/**
 * @param {unknown} typeKey
 * @returns {boolean}
 */
export function isSketchType(typeKey) {
  return normalizeSketchTypeKey(typeKey) === SKETCH_TYPE_KEY;
}
